export default "{% block buy_product_btn %}\n\n{% endblock %}";